import { ResultType } from '../interfaces/Organization';

export class MResultType{
    public id: number;
    public name: string;

    constructor(type: ResultType){
        this.id = type.id;
        this.name = type.nombre
    }
}